import actions from '../../../../redux/actions/ui/dataImport/strategies/bomStrategy.js'
import BaseStrategy from '../BaseStrategy.js'
import ReconcileForm from './ReconcileForm.js'
import EditForm from './EditForm.js'
import {getNounsFromValue} from '../../../../common/tokenizeOptions.js'

export default function BOMStrategy(props) {
  return (
    <BaseStrategy
      {...props}
      actions={actions}
      EditForm={EditForm}
      ReconcileForm={ReconcileForm}
    />
  )
}

BOMStrategy.title = actions.title
const option = {
  value: 'manage_bom',
  display: 'Manage BOMs',
  category: 'kits_boms',
  Component: BOMStrategy,
}
option.nouns = getNounsFromValue(
  `${option.value} ${option.display} ${option.category}`,
)
BOMStrategy.option = option
